export const encodingSymbolsImages: string[] =
  ['./assets/images/encoding/square.png',
    './assets/images/encoding/circle.png'];

export const encodingSymbolsString: string[] =
  ['square', 'circle'];

export const encodingHalfSymbolsImages: string[] =
  ['./assets/images/encoding/half_square.png',
    './assets/images/encoding/half_circle.png',
    './assets/images/encoding/both.png'];
